import apiClient from "./api";
//课程列表
export function customerCoursesList() {
    return apiClient.get(`/v1/customer/courses`);
}
//课程详情
export function customerCoursesParticulars(courseId) {
    return apiClient.get(`/v1/customer/courses/${courseId}`);
}
//课程进度
export function customerCoursesLearninRecords(courseId) {
    return apiClient.get(`/v1/customer/courses/${courseId}/learnin-records`);
}
//添加
export function customerCoursesLearninRecordsAdd(courseId, data) {
    return apiClient.post(`/v1/customer/courses/${courseId}/learnin-records`, data);
}

// 获取课程文章详情
export function customerCoursesLessonDetail(courseId, lessonId) {
    return apiClient.get(`/v1/customer/courses/${courseId}/lesson-detail?lesson_id=${lessonId}`)
}


